import './vendor';

import "./pages/main";
import "./pages/one-museum";
import "./pages/one-event";
import "./pages/universal";
import "./pages/calendar";
import "./pages/museums";
import "./pages/reviews";
import "./pages/results";


// WEBPACK FOOTER //
// ./src/js/main.js